import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from 'react-use'
import { portfolioApiEvents, portfolioApiSelectors } from '.'
import { propertyApiEvents, propertyApiSelectors } from '../property'
import { TMaybeId } from './types'

type TPortfolioProperty = {
  propertyId?: string
  propertyStreetAddress?: string
}

/**
 * Ensures the portfolio and property is fetched and returns useful property fields
 *
 * @param portfolioId Portfolio UUID
 */
export const usePortfolioProperty = (portfolioId: TMaybeId): TPortfolioProperty => {
  const dispatch = useDispatch()
  const portfolio = useSelector(state => portfolioApiSelectors.getPortfolioById(state)(portfolioId))
  const propertyId = portfolio?.propertyId
  const propertyStreetAddress: string | undefined = useSelector(state =>
    propertyApiSelectors.getPropertyStreetAddress(state)(propertyId),
  )

  useEffectOnce(() => {
    if (!portfolio && portfolioId) {
      dispatch(portfolioApiEvents.portfolio_request(portfolioId))
    }
  })

  useEffect(() => {
    if (!propertyStreetAddress && propertyId) {
      dispatch(propertyApiEvents.property_request({ id: propertyId }))
    }
  }, [propertyStreetAddress, dispatch, propertyId])

  return {
    propertyId,
    propertyStreetAddress: portfolio ? propertyStreetAddress : undefined,
  }
}
